import { navigate } from 'gatsby';
import React, { FC, useState } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';
import SubheadingText from '@ui/atoms/SubheadingText';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import BackAndNextNav from '@ui/molecules/BackAndNextNav';
import CenteredGridItem from '@ui/molecules/CenteredGridItem';
import ReadMore from '@ui/molecules/ReadMore';

import flexible from '@ui/styled/Flexible';
import spaced from '@ui/styled/Spaced';

import useMemberInfo from '@hooks/useMemberInfo';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

import theme from '@theme/FolxTheme/';

export interface INewCisgenderIneligibilityNoticeStepProps {
	pageHeadline: string;
	pageSubheader: string;
	pageDescription: string;
	mainTitle: string;
	mainContent: string;
	returnToFolxLabel: string;
}

export interface INewCisgenderIneligibilityNoticeStepProps extends IFlowStepComponentProps {
	pageContent: INewCisgenderIneligibilityNoticeStepProps;
}

const SpacedFlexColumn = spaced(flexible(FlexColumn));
const SpacedGridItem = spaced(CenteredGridItem);

const NewCisgenderIneligibilityNoticeStep: FC<INewCisgenderIneligibilityNoticeStepProps> = ({
	existingFormData,
	handleFormSubmission = () => {
		console.log('no handleFormSubmission provided.');
	},
	stepKey,
	pageContent,
}) => {
	const [submitting, setSubmitting] = useState(false);
	const { memberInfo, loading: memberInfoLoading } = useMemberInfo();

	const {
		pageHeadline,
		pageSubheader,
		pageDescription,
		mainTitle,
		mainContent,
		returnToFolxLabel,
	} = pageContent;

	const {
		handleSubmit,
		register,
		formState: { errors },
	} = useForm({
		defaultValues: existingFormData,
	});

	const onSubmit = async (data: Record<string, unknown>) => {
		setSubmitting(true);
		console.log('submitting.');
		await handleFormSubmission(data, stepKey);
		setSubmitting(false);
	};

	return memberInfoLoading ? (
		<div>Loading...</div>
	) : (
		<SpacedGridItem marginBottom="xxxl">
			<form onSubmit={handleSubmit(onSubmit)}>
				<input type="hidden" value="true" {...register('cisNoticeAcknowledgment')} />
				<input
					type="hidden"
					name="hasValidSsn"
					value={memberInfo?.hasValidSsn ? 'true' : 'false'}
				/>
				<SpacedFlexColumn marginBottom="lgxl" gap="lg">
					<FlexColumn gap="sm">
						<SubheadingText>{pageHeadline}</SubheadingText>
						<WYSIWYGContent dangerouslySetInnerHTML={{ __html: pageSubheader }} />
						<BasicText variant="fineprint">{pageDescription}</BasicText>
					</FlexColumn>
					<ReadMore label={mainTitle}>
						<WYSIWYGContent dangerouslySetInnerHTML={{ __html: mainContent }} />
					</ReadMore>
				</SpacedFlexColumn>
				<BackAndNextNav
					hideBack={true}
					marginTop="xxl"
					marginBottom="xxxl"
					submitLabel={returnToFolxLabel}
					submitting={submitting}
				/>
			</form>
		</SpacedGridItem>
	);
};

export default NewCisgenderIneligibilityNoticeStep;
